import { render, staticRenderFns } from "./FormLoginComponent.vue?vue&type=template&id=510db70c"
import script from "./FormLoginComponent.vue?vue&type=script&lang=js"
export * from "./FormLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./FormLoginComponent.vue?vue&type=style&index=0&id=510db70c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports